module.exports = __webpack_public_path__ + "img/home-9.2d1bec15.png";